import React from 'react';
import Skeleton from 'flow/components/ui-components/Skeleton';

const TicketsListSkeleton = () => (
    <div className="overflow-y-scroll">
        <TicketsListItemSkeleton />
        <TicketsListItemSkeleton />
        <TicketsListItemSkeleton />
        <TicketsListItemSkeleton />
        <TicketsListItemSkeleton />
        <TicketsListItemSkeleton />
        <TicketsListItemSkeleton />
        <TicketsListItemSkeleton />
        <TicketsListItemSkeleton />
        <TicketsListItemSkeleton />
    </div>
);

export default TicketsListSkeleton;

export const TicketsListItemSkeleton = () => (
    <div className="animate-fade flex w-full items-start gap-x-2 p-2 text-gray-200">
        <div className="flex h-6 items-center">
            <Skeleton.Icon className="size-6 rounded-sm" />
        </div>
        <div className="flex grow flex-col">
            <div className="flex h-6 items-center justify-between">
                <Skeleton.Text className="w-28" />
                <Skeleton.Text className="w-8" />
            </div>
            <div className="flex h-6 items-center">
                <Skeleton.Text className="w-40" />
            </div>
            <div className="flex h-6 items-center gap-1">
                <Skeleton.Text className="w-5" />
                <Skeleton.Text className="w-24" />
            </div>
            <div className="flex h-8 items-end gap-1">
                <div className="h-6 w-16 rounded-lg bg-gray-200" />
                <div className="h-6 w-20 rounded-lg bg-gray-200" />
                <div className="h-6 w-12 rounded-lg bg-gray-200" />
            </div>
        </div>
    </div>
);
